import styles from './AccessOverview.module.scss';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { FragmentType, getFragmentData, graphql } from 'client/gql';
import { isIosOrAndroid } from 'utils/isIosOrAndroid';
import { Capacitor } from '@capacitor/core';

const AccessOverviewFormFieldsDocument = graphql(`
  fragment AccessOverviewFormFields on Query {
    profiles(where: $profilesWhere, options: $profilesOptions) {
      uuid
      __typename
      threemaId
      threemaConnection {
        __typename
        edges {
          __typename
          properties {
            threemaId
            workPass
            workUser
          }
        }
      }
    }
  }
`);

type AccessOverviewProps = {
  query: FragmentType<typeof AccessOverviewFormFieldsDocument> | undefined;
};

export const AccessOverview = ({ query }: AccessOverviewProps) => {
  const fragment = getFragmentData(AccessOverviewFormFieldsDocument, query);
  const profile = fragment?.profiles[0];
  const threemaInfo = profile?.threemaConnection.edges[0]?.properties;
  const combinedProfile = { ...profile, ...threemaInfo };
  const { t } = useTranslation();

  return (
    <div className={styles['access-overview']}>
      {!combinedProfile.threemaId && (
        <div className={classNames(styles.account, styles.threema)}>
          <div className={styles.header}>Threema</div>
          <div className={styles.credentials}>
            <div>
              <div className={styles.description}>{t('common.username')}:</div>
              {combinedProfile.workUser}
            </div>
            <div>
              <div className={styles.description}>{t('common.password')}:</div>
              {combinedProfile.workPass}
            </div>
            <div>
              <div className={styles.description}>Threema ID:</div>
              {combinedProfile.threemaId}
            </div>
          </div>
        </div>
      )}
      {!Capacitor.isNativePlatform() && (
        <div className={styles.account}>
          <div className={styles.header}>{t('app.download')}</div>
          <div className={styles.credentials}>
            <div>
              <a
                className={classNames(styles.link, styles.google)}
                href='https://play.google.com/store/apps/details?id=eu.tks.bp.main'
                target='_blank'
                rel='noreferrer'
              >
                <img src='/app-store-google.png' alt='a link to the Google play store' />
              </a>
              <a
                className={classNames(styles.link, styles.apple)}
                href='https://apps.apple.com/app/tk-bildungsplattform/id6502827344'
                target='_blank'
                rel='noreferrer'
              >
                <img src='/app-store-apple.svg' alt='a link to the Apple app store' />
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
